import { Component, OnInit } from '@angular/core';
import { appSettings } from 'src/etc/AppSettings';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  private apiImagenes : string = appSettings.apiImagenes;

  constructor() { }

  ngOnInit() {
  }

}
